import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-circle",
  "use": "check-circle-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"check-circle\">\n    <path fill-rule=\"evenodd\" d=\"M7.5 0C11.642 0 15 3.358 15 7.5c0 4.142-3.358 7.5-7.5 7.5C3.358 15 0 11.642 0 7.5 0 3.358 3.358 0 7.5 0zm3.915 4.395c-.297-.225-.72-.167-.946.13l-3.834 5.06-2.447-2.206c-.277-.25-.704-.227-.953.05-.25.276-.228.703.05.953l2.992 2.697c.294.265.751.221.99-.094l4.278-5.644c.225-.297.167-.72-.13-.946z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol